export default {
  light: {
    background: "var(--colorsComponentsMenuSpringStandard500)",
    color: "var(--colorsComponentsMenuYin090)",
    selected: "var(--colorsComponentsMenuSpringStandard700)",
    submenuOpenedBackground: "var(--colorsComponentsMenuSpringParent600)",
    submenuBackground: "var(--colorsComponentsMenuSpringParent500)",
    submenuSelected: "var(--colorsComponentsMenuSpringParent700)",
    submenuItemBackground: "var(--colorsComponentsMenuSpringChild500)",
    submenuItemBackgroundHover: "var(--colorsComponentsMenuSpringChild600)",
    title: "var(--colorsComponentsMenuYin065)",
    alternate: "var(--colorsComponentsMenuSpringChildAlt500)",
    alternateHover: "var(--colorsComponentsMenuSpringChildAlt600)",
    divider: "var(--colorsComponentsMenuSpringChild400)"
  },
  dark: {
    background: "var(--colorsComponentsMenuAutumnStandard500)",
    color: "var(--colorsComponentsMenuYang100)",
    selected: "var(--colorsComponentsMenuAutumnStandard700)",
    submenuOpenedBackground: "var(--colorsComponentsMenuAutumnParent600)",
    submenuBackground: "var(--colorsComponentsMenuAutumnParent500)",
    submenuSelected: "var(--colorsComponentsMenuAutumnParent700)",
    submenuItemBackground: "var(--colorsComponentsMenuAutumnChild500)",
    submenuItemBackgroundHover: "var(--colorsComponentsMenuAutumnChild600)",
    title: "var(--colorsComponentsMenuYang080)",
    alternate: "var(--colorsComponentsMenuAutumnChildAlt500)",
    alternateHover: "var(--colorsComponentsMenuAutumnChildAlt600)",
    divider: "var(--colorsComponentsMenuAutumnChild400)"
  },
  black: {
    background: "var(--colorsComponentsMenuWinterStandard500)",
    color: "var(--colorsComponentsMenuYang100)",
    selected: "var(--colorsComponentsMenuWinterStandard700)",
    submenuOpenedBackground: "var(--colorsComponentsMenuWinterParent600)",
    submenuBackground: "var(--colorsComponentsMenuWinterParent500)",
    submenuSelected: "var(--colorsComponentsMenuWinterParent700)",
    submenuItemBackground: "var(--colorsComponentsMenuWinterChild500)",
    submenuItemBackgroundHover: "var(--colorsComponentsMenuWinterChild600)",
    title: "var(--colorsComponentsMenuYang080)",
    alternate: "var(--colorsComponentsMenuWinterChildAlt500)",
    alternateHover: "var(--colorsComponentsMenuWinterChildAlt600)",
    divider: "var(--colorsComponentsMenuWinterChild400)"
  },
  white: {
    background: "var(--colorsComponentsMenuSummerStandard500)",
    color: "var(--colorsComponentsMenuYin090)",
    selected: "var(--colorsComponentsMenuSummerStandard700)",
    submenuOpenedBackground: "var(--colorsComponentsMenuSummerParent600)",
    submenuBackground: "var(--colorsComponentsMenuSummerParent500)",
    submenuSelected: "var(--colorsComponentsMenuSummerParent700)",
    submenuItemBackground: "var(--colorsComponentsMenuSummerChild500)",
    submenuItemBackgroundHover: "var(--colorsComponentsMenuSummerChild600)",
    title: "var(--colorsComponentsMenuYin065)",
    alternate: "var(--colorsComponentsMenuSummerChildAlt500)",
    alternateHover: "var(--colorsComponentsMenuSummerChildAlt600)",
    divider: "var(--colorsComponentsMenuSummerChild400)"
  }
};